import {
  dmdDiagnoses,
  epilepsyDiagnoses,
  huntingtonDiagnoses,
  keoDiagnoses,
  mgravisDiagnoses,
  msDiagnoses,
  nmosdDiagnoses,
  parkinsonDiagnoses,
  polyneuroDiagnoses,
  reoDiagnoses,
  sleepApneaDiagnoses,
  smaDiagnoses,
} from 'Routes/Diagnosis/utils/definitions';

const defaultReduceCallback = (acc: Record<string, string[]>, code: string) => {
  acc[code] = [code];
  return acc;
};

// 1. Map diagnoses to formats used in extended search

const msDiagnosesMap = {
  keo: keoDiagnoses,
  radiologicallyIsolatedSyndrome: reoDiagnoses,
  ms: msDiagnoses,
  nmosd: nmosdDiagnoses,
};

const parkinsonDiagnosesMap = parkinsonDiagnoses.reduce(defaultReduceCallback, {});

const sleepApneaDiagnosesMap = sleepApneaDiagnoses
  .toSorted((a, b) => -Number(a.includes('Suspicion')) - -Number(b.includes('Suspicion')))
  .reduce(defaultReduceCallback, {});

const mgravisDiagnosesMap = mgravisDiagnoses.reduce(defaultReduceCallback, {});

const smaDiagnosesMap = smaDiagnoses.reduce(defaultReduceCallback, {});

const dmdDiagnosesMap = dmdDiagnoses.reduce(defaultReduceCallback, {});

const epilepsyDiagnosesMap = epilepsyDiagnoses.reduce(defaultReduceCallback, {});

const polyneuroDiagnosesMap = polyneuroDiagnoses.reduce(defaultReduceCallback, {});

// 2. Combine

export const diagnoses: Record<string, string[]> = {
  ...msDiagnosesMap,
  ...parkinsonDiagnosesMap,
  ...sleepApneaDiagnosesMap,
  ...mgravisDiagnosesMap,
  ...smaDiagnosesMap,
  ...dmdDiagnosesMap,
  ...epilepsyDiagnosesMap,
  ...polyneuroDiagnosesMap,
  noCropping: [''],
};

export const diagnosesByPlatform: Partial<Record<Platform, string[]>> = {
  ms: [...keoDiagnoses, ...reoDiagnoses, ...msDiagnoses, ...nmosdDiagnoses],
  parkinson: parkinsonDiagnoses,
  sleepApnea: sleepApneaDiagnoses,
  mgravis: mgravisDiagnoses,
  sma: smaDiagnoses,
  dmd: dmdDiagnoses,
  epilepsy: epilepsyDiagnoses,
  huntington: huntingtonDiagnoses,
  polyneuro: polyneuroDiagnoses,
};
